import styled, { css, keyframes } from 'styled-components'

import { IconV2 } from '../Icon'

const EnableAnimationPanel = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`

const DisableAnimationPanel = keyframes`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`

export const Box = styled.div<{ $enabled: boolean }>`
  position: fixed;
  bottom: 100px;
  right: 0;
  max-height: 80%;
  min-height: 48px;
  width: 360px;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  box-shadow: var(--theme-boxShadows-offset-offset100Y4);
  background: var(--theme-colors-global-general-main);
  z-index: 1005;

  ${(p) =>
    p.$enabled
      ? css`
          opacity: 1;
          animation: ${EnableAnimationPanel} 250ms ease-out;
        `
      : css`
          opacity: 0;
          animation: ${DisableAnimationPanel} 250ms ease-out;
        `};
`

export const Header = styled.header<{ $shown: boolean }>`
  min-height: 48px;
  font: var(--theme-typography-h5-regular);
  display: flex;
  align-items: center;
  padding-left: 8px;
  padding-right: 12px;
  gap: 0;
  cursor: pointer;

  ${(p) =>
    p.$shown &&
    css`
      border-bottom: 1px solid var(--theme-colors-global-grey-grey300);
    `}
`

export const Title = styled.div`
  overflow: hidden;
  text-wrap: nowrap;
  text-overflow: ellipsis;
`

export const Actions = styled.div`
  margin-left: auto;
`

export const ContentInside = styled.div`
  padding: 8px 0 12px;
  overflow: hidden;
`

export const Content = styled.section`
  overflow: hidden;
  overflow-y: auto;

  transition:
    max-height 0.25s ease-in-out,
    opacity 0.25s ease-in-out;

  &.shown {
    opacity: 1;
    max-height: 80vh;
  }

  &.hidden {
    opacity: 0;
    max-height: 0;
  }
`

export const CloseIcon = styled(IconV2)`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
`
